/* eslint-disable no-restricted-properties */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import get from 'lodash/get';

import { appTypes, candidateRegistrationWorkflowCodes, userAccountTypes } from 'shared/constants';
// eslint-disable-next-line import/no-cycle
import { getAccountTypes, isAgentIntersect, wipeStorage, logDebug } from 'shared/functions';

import noImage from 'assets/images/no-user-image.gif';

export const temporaryUser = (userDetails: any) => {
  if (!userDetails.rw) {
    return true;
  }

  return userDetails.rw.workflow_state.code !== candidateRegistrationWorkflowCodes.registered;
};

export const getParsedUserByAppType = (appType: ValuesOf<typeof appTypes>) => {
  if (!appType) {
    throw new Error('appType should be passed to getParsedUserByAppType()');
  }

  let user;
  const wipeAndReturnEmpty = () => {
    wipeStorage();
    return {};
  };

  try {
    user = JSON.parse(localStorage.user);
    if (!user) {
      return wipeAndReturnEmpty();
    }
    window.isAgent = appType === appTypes.agent ? isAgentIntersect(user.accountTypes) : false;
    window.isContact = appType === appTypes.agent ? getAccountTypes(user).includes(userAccountTypes.contact) : false;
    window.isCandidate =
      appType === appTypes.candidate ? getAccountTypes(user).includes(userAccountTypes.candidate) : false;
  } catch (err) {
    return wipeAndReturnEmpty();
  }

  // TODO To switch to new agent ids only
  if (parseInt(user.userId || 0, 0) === 8) {
    wipeStorage();
    return window.location.reload();
  }

  return user;
};

export const profileImage = (profile) => {
  if (!(profile.photos || []).length) {
    return noImage;
  }
  const profilePhoto = profile.photos.find((item) => item.isAvatar);
  if (!profilePhoto) {
    return noImage;
  }
  return profilePhoto.url;
};

export const rateClass = (rate: number) => {
  if (rate < 1) {
    return 'one';
  } else if (rate < 2) {
    return 'two';
  } else if (rate < 3) {
    return 'three';
  } else if (rate < 4) {
    return 'four';
  }
  return 'five';
};

export const getCvUrl = (candidate) => candidate.cvs[0].url;

export const updateCandidate = (candidates, compositeId, assignment, reportError = true) => {
  const indexes = [];
  candidates.forEach((candidate, index) => {
    if (candidate.compositeId === compositeId) {
      indexes.push(index);
    }
  });
  if (!indexes.length) {
    if (reportError) {
      logDebug(`Failed to find candidate ${compositeId}`);
    }
    return candidates;
  }
  return candidates.map((candidate, index) => ({
    ...candidate,
    ...(indexes.includes(index)
      ? {
          ...assignment,
          updated: true,
        }
      : {}),
  }));
};

// Generate single string from user params
export const userName = (user) => get(user, 'name.displayName' || '');

export const updateFirstName = ({ firstName }) => (firstName ? (localStorage.firstName = firstName) : '');
